import Axios from 'axios'
import { ENDPOINT,  } from '../constant'

export default Axios.create({
    baseURL: `${ENDPOINT.PAYMENT_BASE_URL}${ENDPOINT.API_VERSION.V1}`
})
